import React from 'react';
import styled from 'styled-components';
import { Song } from '../types';

const Card = styled.div`
  background: var(--card-bg);
  border-radius: 12px;
  padding: 32px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 24px;
  backdrop-filter: blur(10px);
  
  @media (max-width: 768px) {
    padding: 20px;
    margin-top: 16px;
  }
`;

const Title = styled.h3`
  color: var(--primary-color);
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.3rem;
  
  @media (max-width: 768px) {
    margin-bottom: 12px;
    font-size: 1.1rem;
  }
`;

const LyricsText = styled.div`
  color: var(--text-muted);
  line-height: 1.8;
  white-space: pre-line;
  max-height: 400px;
  overflow-y: auto;
  font-size: 1.1rem;
  
  @media (max-width: 768px) {
    max-height: 200px;
    font-size: 0.95rem;
    line-height: 1.6;
  }
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: var(--primary-color);
    border-radius: 4px;
  }
`;

const NoLyrics = styled.div`
  color: var(--text-muted);
  font-style: italic;
  text-align: center;
  padding: 20px;
`;

interface LyricsCardProps {
  song: Song;
}

const LyricsCard: React.FC<LyricsCardProps> = ({ song }) => {
  return (
    <Card>
      <Title>
        🎤 Letra da Música
      </Title>
      {song.lyrics ? (
        <LyricsText>{song.lyrics}</LyricsText>
      ) : (
        <NoLyrics>
          Esta música não possui letra cadastrada
        </NoLyrics>
      )}
    </Card>
  );
};

export default LyricsCard;